import dinero from "dinero.js";

import { createDinero, dineroToNumber } from "../utils/money";

const TAX = 21;

const MINIMUM = 2_000_00;
const MAXIMUM = 86_500_00;

const RANGES: ReadonlyArray<{ maxAmount: number; percentage: number }> = [
	{ maxAmount: 500_000_00, percentage: 2 },
	{ maxAmount: 1_000_000_00, percentage: 0.9 },
	{ maxAmount: 3_000_000_00, percentage: 0.5 },
	{ maxAmount: 30_000_000_00, percentage: 0.1 },
	{ maxAmount: 100_000_000_00, percentage: 0.05 },
];

export declare interface NotaryReward {
	reward: dinero.Dinero;
	tax: dinero.Dinero;
}

export function calculateNotaryReward(value: dinero.Dinero): NotaryReward {
	if (value.getCurrency() !== "CZK") {
		throw new Error("Not supported");
	}

	const money = (amount: number): dinero.Dinero => {
		return createDinero({
			amount,
			currency: value.getCurrency(),
		});
	};

	let result = money(0);
	let used = money(0);

	value = money(Math.ceil(dineroToNumber(value) / 100) * 100 * 100);

	for (const range of RANGES) {
		if (used.greaterThanOrEqual(value)) {
			break;
		}

		const max = money(range.maxAmount);
		const usableMax = dinero.minimum([value, max]);
		const use = usableMax.subtract(used);

		result = result.add(use.multiply(range.percentage / 100));
		used = used.add(use);
	}

	const minimum = money(MINIMUM);
	const maximum = money(MAXIMUM);

	if (result.lessThan(minimum)) {
		return create(minimum);
	}

	if (result.greaterThan(maximum)) {
		return create(maximum);
	}

	return create(result);
}

function create(reward: dinero.Dinero): NotaryReward {
	reward = createDinero({
		amount: Math.ceil(dineroToNumber(reward) / 10) * 10 * 100,
		currency: reward.getCurrency(),
	});

	return {
		reward,
		tax: reward.multiply(TAX / 100),
	};
}
